function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1a1a1a;}.cls-2{fill:#fff;}.cls-3{fill:#2c2f38;}.cls-4{fill:#f0c419;}.cls-5{fill:#4fba6f;}.cls-6{fill:#2fa8cc;}.cls-7{fill:#285680;}.cls-8{fill:#3d324c;}.cls-9{fill:#802d40;}.cls-10{fill:#cc4b4c;}.cls-11{fill:#e57e25;}.cls-12{fill:#4482c3;}.cls-13{fill:#e6e7e8;}.cls-14{fill:#9fc9d3;}.cls-15{fill:#f29c1f;}.cls-16{fill:#f3d55b;}.cls-17{fill:#fb7b76;}.cls-18{fill:#d75e72;}.cls-19{fill:#7d6599;}.cls-20{fill:#7ed09e;}.cls-21{fill:#00a99d;stroke:#fff;stroke-miterlimit:10;stroke-width:5.24px;}.cls-22{fill:#d6a069;}.cls-23{fill:#c68b59;}.cls-24{fill:#3b2519;}.cls-25{fill:#1d110c;}.cls-26{fill:#b4724e;}.cls-27{fill:#2f57c0;}.cls-28{fill:#2e3192;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M199.35,1015.22a611.9,611.9,0,0,1-83.51-92.54C81.09,874.94,55,823.28,38.21,769.13c-18.17-58.73-25.49-121-21.75-185,3.24-55.58,14.78-112.68,34.29-169.71,35.66-104.23,92.17-189.9,133.16-235.32,48-53.15,112.77-94.16,192.6-121.89,79.66-27.68,173-41.71,277.3-41.71,78.23,0,162.33,8,250,23.7,89.41,16,182.94,40.23,278,71.91,197.93,66,399.12,162.46,598.14,286.92L1643,1015.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M653.81,31C731.12,31,814.3,38.89,901,54.45c88.68,15.91,181.48,39.92,275.84,71.36,97.2,32.39,196.8,72.93,296,120.48a3059.61,3059.61,0,0,1,289.5,159.1l-59.17,266.66-72.7,327.67H205.38a594.67,594.67,0,0,1-77-86.16c-33.75-46.37-59.1-96.5-75.35-149C35.39,707.6,28.3,647.2,31.93,585c3.16-54.18,14.43-109.89,33.49-165.59a741.54,741.54,0,0,1,63.36-137.17c21-35.46,44.65-68.41,66.64-92.78,46.2-51.19,108.84-90.77,186.17-117.64C459.61,44.74,551.2,31,653.81,31m0-31C442.06,0,273,57.27,172.41,168.72c-84.77,93.92-229.09,346.23-149,605,38.89,125.67,117.51,210.22,170,257h1462q71-320,142-640C1378.49,126.83,968.91,0,653.81,0Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Page-1"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  className: "cls-3",
  cx: 1229.41,
  cy: 594.72,
  rx: 322,
  ry: 329
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "cls-4",
  d: "M1457.14,362l-86.39,88.27a197.56,197.56,0,0,0-141.34-59.79V265.72C1314.84,265.58,1396.8,300.24,1457.14,362Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M1229.41,265.72V390.51a197.57,197.57,0,0,0-141.35,59.79L1001.68,362C1062,300.24,1144,265.58,1229.41,265.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M1001.68,362l86.38,88.27a206.28,206.28,0,0,0-58.52,144.42H907.41C907.27,507.43,941.2,423.69,1001.68,362Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M1029.54,594.72a206.31,206.31,0,0,0,58.52,144.42l-86.38,88.26C941.2,765.75,907.27,682,907.41,594.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M1088.06,739.14a197.52,197.52,0,0,0,141.35,59.78v124.8c-85.43.14-167.4-34.53-227.73-96.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M1370.75,739.14l86.39,88.26c-60.34,61.79-142.3,96.46-227.73,96.32V798.92A197.51,197.51,0,0,0,1370.75,739.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M1429.27,594.72h122.14c.13,87.28-33.79,171-94.27,232.68l-86.39-88.26A206.31,206.31,0,0,0,1429.27,594.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1457.14,362c60.48,61.66,94.4,145.4,94.27,232.69H1429.27a206.28,206.28,0,0,0-58.52-144.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M1182.33,546.61a65.67,65.67,0,0,1,84.27-8.46c26.46,18.09,36.74,52.76,24.53,82.8s-43.49,47.1-74.71,40.72-53.68-34.42-53.63-66.95A68.17,68.17,0,0,1,1182.33,546.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M1316.05,337.13a260.56,260.56,0,0,0-32.61-9.07,11.2,11.2,0,0,1-8.55-7.49,11.54,11.54,0,0,1,2.25-11.27,11,11,0,0,1,10.74-3.47,283.66,283.66,0,0,1,35.33,9.91,11.37,11.37,0,0,1,7.32,12.59,11.17,11.17,0,0,1-10.93,9.47A10.79,10.79,0,0,1,1316.05,337.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M1415.94,400.46a268.45,268.45,0,0,0-60.13-45.38,11.48,11.48,0,0,1-.54-19.65,10.93,10.93,0,0,1,11.1-.32,291.26,291.26,0,0,1,65.12,49.15,11.51,11.51,0,0,1,2.5,12.39,11.08,11.08,0,0,1-10.27,7.05A10.91,10.91,0,0,1,1415.94,400.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M1495.89,594.72a274.35,274.35,0,0,0-21.89-108,11.57,11.57,0,0,1,1.25-11.28,11,11,0,0,1,10.18-4.54,11.13,11.13,0,0,1,8.94,6.74,297.69,297.69,0,0,1,23.73,117.07,11.11,11.11,0,1,1-22.21,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M1088.06,450.3l94.27,96.31a68.17,68.17,0,0,0-19.54,48.11H1029.54A206.28,206.28,0,0,1,1088.06,450.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M1370.75,450.3a206.28,206.28,0,0,1,58.52,144.42H1296a68.22,68.22,0,0,0-19.55-48.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M1182.33,546.61a65.67,65.67,0,0,1,84.27-8.46c26.46,18.09,36.74,52.76,24.53,82.8s-43.49,47.1-74.71,40.72-53.68-34.42-53.63-66.95A68.17,68.17,0,0,1,1182.33,546.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M1370.75,450.3l-94.27,96.31a65.29,65.29,0,0,0-47.07-20V390.51A197.56,197.56,0,0,1,1370.75,450.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M1296,594.72h133.24a206.31,206.31,0,0,1-58.52,144.42l-94.27-96.32A68.18,68.18,0,0,0,1296,594.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M1276.48,642.82l94.27,96.32a197.51,197.51,0,0,1-141.34,59.78V662.79A65.3,65.3,0,0,0,1276.48,642.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M1182.33,642.82a65.31,65.31,0,0,0,47.08,20V798.92a197.52,197.52,0,0,1-141.35-59.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M1162.79,594.72a68.12,68.12,0,0,0,19.54,48.1l-94.27,96.32a206.31,206.31,0,0,1-58.52-144.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-20",
  d: "M1229.41,390.51V526.65a65.3,65.3,0,0,0-47.08,20l-94.27-96.31A197.57,197.57,0,0,1,1229.41,390.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1182.33,546.61a65.67,65.67,0,0,1,84.27-8.46c26.46,18.09,36.74,52.76,24.53,82.8s-43.49,47.1-74.71,40.72-53.68-34.42-53.63-66.95A68.17,68.17,0,0,1,1182.33,546.61Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M571.26,725.29H546a44.32,44.32,0,0,0-44.12,44.43V871.28A44.33,44.33,0,0,0,546,915.72h25.22a44.33,44.33,0,0,0,44.13-44.44V769.72A44.33,44.33,0,0,0,571.26,725.29Zm6.3,146a6.33,6.33,0,0,1-6.3,6.35H546a6.34,6.34,0,0,1-6.3-6.35V769.72a6.34,6.34,0,0,1,6.3-6.35h25.22a6.33,6.33,0,0,1,6.3,6.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M420,877.63H401.05V744.33a19,19,0,0,0-18.91-19H344.32a19,19,0,0,0,0,38.08h18.91V877.63H344.32a19,19,0,0,0,0,38.09H420a19,19,0,0,0,0-38.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M924.28,725.29H899.06a44.32,44.32,0,0,0-44.12,44.43V871.28a44.33,44.33,0,0,0,44.12,44.44h25.22a44.33,44.33,0,0,0,44.13-44.44V769.72A44.33,44.33,0,0,0,924.28,725.29Zm6.3,146a6.33,6.33,0,0,1-6.3,6.35H899.06a6.34,6.34,0,0,1-6.3-6.35V769.72a6.34,6.34,0,0,1,6.3-6.35h25.22a6.33,6.33,0,0,1,6.3,6.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M773,877.63H754.07V744.33a19,19,0,0,0-18.91-19H697.34a19,19,0,0,0,0,38.08h18.91V877.63H697.34a19,19,0,0,0,0,38.09H773a19,19,0,0,0,0-38.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M571.26,495.5H546a44.33,44.33,0,0,0-44.12,44.44V641.5A44.32,44.32,0,0,0,546,685.93h25.22a44.33,44.33,0,0,0,44.13-44.43V539.94A44.33,44.33,0,0,0,571.26,495.5Zm6.3,146a6.33,6.33,0,0,1-6.3,6.35H546a6.34,6.34,0,0,1-6.3-6.35V539.94a6.33,6.33,0,0,1,6.3-6.35h25.22a6.32,6.32,0,0,1,6.3,6.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M420,647.85H401.05V514.54a19,19,0,0,0-18.91-19H344.32a19,19,0,0,0,0,38.09h18.91V647.85H344.32a19,19,0,0,0,0,38.08H420a19,19,0,0,0,0-38.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M747.77,495.5H722.55a44.33,44.33,0,0,0-44.12,44.44V641.5a44.32,44.32,0,0,0,44.12,44.43h25.22A44.33,44.33,0,0,0,791.9,641.5V539.94A44.33,44.33,0,0,0,747.77,495.5Zm6.3,146a6.33,6.33,0,0,1-6.3,6.35H722.55a6.34,6.34,0,0,1-6.3-6.35V539.94a6.33,6.33,0,0,1,6.3-6.35h25.22a6.32,6.32,0,0,1,6.3,6.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M949.49,647.85H930.58V514.54a19,19,0,0,0-18.91-19H873.85a19,19,0,0,0,0,38.09h18.91V647.85H873.85a19,19,0,0,0,0,38.08h75.64a19,19,0,0,0,0-38.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M394.75,265.72H369.53a44.32,44.32,0,0,0-44.12,44.43V411.71a44.33,44.33,0,0,0,44.12,44.44h25.22a44.33,44.33,0,0,0,44.13-44.44V310.15A44.33,44.33,0,0,0,394.75,265.72Zm6.3,146a6.33,6.33,0,0,1-6.3,6.35H369.53a6.34,6.34,0,0,1-6.3-6.35V310.15a6.34,6.34,0,0,1,6.3-6.35h25.22a6.33,6.33,0,0,1,6.3,6.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M596.48,418.06H577.56V284.76a19,19,0,0,0-18.91-19H520.83a19,19,0,0,0,0,38.08h18.91V418.06H520.83a19,19,0,0,0,0,38.09h75.65a19,19,0,0,0,0-38.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M924.28,265.72H899.06a44.32,44.32,0,0,0-44.12,44.43V411.71a44.33,44.33,0,0,0,44.12,44.44h25.22a44.33,44.33,0,0,0,44.13-44.44V310.15A44.33,44.33,0,0,0,924.28,265.72Zm6.3,146a6.33,6.33,0,0,1-6.3,6.35H899.06a6.34,6.34,0,0,1-6.3-6.35V310.15a6.34,6.34,0,0,1,6.3-6.35h25.22a6.33,6.33,0,0,1,6.3,6.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M773,418.06H754.07V284.76a19,19,0,0,0-18.91-19H697.34a19,19,0,0,0,0,38.08h18.91V418.06H697.34a19,19,0,0,0,0,38.09H773a19,19,0,0,0,0-38.09Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-22",
  x: 870.88,
  y: 829.02,
  width: 98.82,
  height: 111.8
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M870.88,842.19s41.57,26.74,98.82,20.54V829H870.88Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-23",
  cx: 728.39,
  cy: 655.66,
  rx: 48.22,
  ry: 55.57
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-23",
  cx: 1112.19,
  cy: 655.66,
  rx: 48.22,
  ry: 55.57
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-22",
  d: "M1112,549.52c0-81.85-59.29-141.75-191.7-141.75s-191.71,59.9-191.71,141.75S714.75,847,920.29,847,1112,631.38,1112,549.52Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-24",
  cx: 826.91,
  cy: 642.35,
  rx: 20.75,
  ry: 22.96
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-2",
  cx: 817.87,
  cy: 632.22,
  rx: 6.21,
  ry: 6.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-25",
  d: "M793.71,585.46c9.82,4.95,25.57-16.85,61.64,2.12C861.93,591,865.85,558,827.19,558,793.71,558,787.78,582.46,793.71,585.46Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-24",
  cx: 1016.22,
  cy: 642.35,
  rx: 20.75,
  ry: 22.96
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-2",
  cx: 1007.18,
  cy: 632.22,
  rx: 6.21,
  ry: 6.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-25",
  d: "M1046.86,585.46c-9.81,4.95-25.57-16.85-61.64,2.12C978.65,591,974.72,558,1013.39,558,1046.86,558,1052.79,582.46,1046.86,585.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M920.29,723.11c-20.51,0-32.86-15.47-32.86-8s5.93,21.72,32.86,21.72,32.86-14.23,32.86-21.72S940.79,723.11,920.29,723.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M920.29,792c-7.1,0-11.37-5.36-11.37-2.76s2.05,7.5,11.37,7.5,11.36-4.91,11.36-7.5S927.38,792,920.29,792Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M920.29,772.87c-32.5,0-52.09-13.37-52.09-10s9.4,16.72,52.09,16.72,52.08-13.33,52.08-16.72S952.79,772.87,920.29,772.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M920.29,873.94V999.72H680.17C680.17,948.81,806.65,873.94,920.29,873.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M920.29,873.94V999.72h240.12C1160.41,948.81,1033.93,873.94,920.29,873.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M920.29,873.94c-24.17,0-48.92,3.41-72.92,9.24.17.21,26.62,34.68,72.92,34.68,42.87,0,71.38-29.52,75.51-34.06C971,877.58,945.33,873.94,920.29,873.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-22",
  d: "M870.88,878.29s14.45,18.11,49.4,18.11,49.41-18.11,49.41-18.11S918.44,859.44,870.88,878.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-25",
  d: "M1075.29,377.14c-117.42-76.22-239.63-93.87-299.67-43.59-16.36,13.69-34.22,37.55-46.73,61.27-28.28,53.63-28.82,103.91-27.13,137.11,4.45,87.41,16.31,138.68,30.33,132.35s6.73-64,8.21-77.35,14.82-73.53,104.76-64.55,165.72-24,165.72-24,30.51,39,50.59,46.42c40.11,14.91,27,114.34,42.68,114.34S1196.84,429.55,1075.29,377.14Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1105.49,639.49h-13.92c-6.08-37.58-37.36-66.33-75-66.33-37.18,0-68.31,27.32-75.52,63.54-6.2-5.4-13.27-8.27-20.73-8.27s-14.52,2.87-20.73,8.26c-7.12-36.22-37.87-63.53-74.61-63.53-40.33,0-73.48,32.18-76.76,73h-13.1a6.64,6.64,0,0,0,0,13.27h13.1c3.28,40.79,36.43,73,76.76,73,41.3,0,74.95-34.54,76.07-77.42,5.45-8.52,12.23-13.24,19.27-13.24s13.82,4.72,19.26,13.24c1.14,42.88,35.2,77.42,77,77.42,42,0,76.17-35.71,76.17-79.6h12.78a6.64,6.64,0,0,0,0-13.27ZM825,719.09c-35.46,0-64.32-29.76-64.32-66.33s28.86-66.34,64.32-66.34,63.41,29.14,63.41,66.34S860.51,719.09,825,719.09Zm191.59,0c-35.46,0-64.32-29.76-64.32-66.33s28.86-66.34,64.32-66.34,63.4,29.14,63.4,66.34S1052.1,719.09,1016.54,719.09Z"
})));

var SvgSplash = function SvgSplash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1797.41 1030.72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSplash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/splash.49d54f0c.svg";
export { ForwardRef as ReactComponent };